import {
  REQUEST_SUBSCRIBERS,
  RECEIVE_SUBSCRIBERS,
  ADD_SUBSCRIBER,
  REMOVE_SUBSCRIBER
} from './subscriberActions'
import { LOG_OUT } from '../../top-panel/authorized-controls/authorizationActions'

const initialState = {
  isLoading: false,
  data: undefined
}

export default (
  state = initialState,
  action
) => {
  switch (action.type) {
    case REQUEST_SUBSCRIBERS:
      return { ...state, isLoading: true }

    case RECEIVE_SUBSCRIBERS:
      return {
        data: action.subscribers,
        isLoading: false
      }
    case ADD_SUBSCRIBER:
      return { ...state, data: [...state.data, action.subscriber] }
    case REMOVE_SUBSCRIBER:
      return { ...state, data: state.data.filter(item => (item.id !== action.payload.id)) }
    case LOG_OUT:
      return { ...initialState }
    default: return state
  }
}
